// src/utils/PermissionLoader.tsx
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {jwtDecode} from "jwt-decode";
import { setPermissions, setRoleAndUser } from "../core/data/redux/permissionSlice";
import { getAllPermissions } from "../core/api/permissionMatrix";

const PermissionLoader = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    try {
      const decoded: any = jwtDecode(token);

      dispatch(
        setRoleAndUser({
          role: decoded.role,
          userId: decoded.id,
        })
      );

      getAllPermissions(token).then((permissions) => {
        dispatch(setPermissions(permissions));
      });
    } catch (error) {
      console.error("Invalid token, clearing it");
      localStorage.removeItem("authToken");
    }
  }, []);

  return null; // this component doesn’t render anything
};

export default PermissionLoader;
